import {isIEBrowser} from '@/utils'
import {CertInfo, CAhb} from '../cainfo'

var SecCtrl;
var userCA;

var Hnca = function () {
    this.caname = CAhb.hnca;
    this.caIP = "";
    this.serverUrl = "";
    this.caPort = "";
    this.random = "";
    this.certInfo = new CertInfo();
    this.certList = [];
    this.provider = 'GGZY';
    this.caOCX = undefined;
    this.hasInit = false;
};

function danweiName(arr) {
    let array = arr.split(',')
    let arr1 = array[3].split('=')
    let name = arr1[1]
    return name
}

Hnca.prototype = {
    /**
     * 获取控件对象
     */
    getHnObjcet: function (objname) {
        return document.getElementById(objname);
    },
    /**
     * 初始化Ocx插件
     */
    initOcxPlugin() {
        SecCtrl = this.getHnObjcet("SecCtrl");
        if (SecCtrl === undefined || !isIEBrowser()) {
            alert("请确认河南CA的UKEY是否正确插入");
        }
        this.init(this.provider, '', '')
        if (!this.init(this.provider, '', '')) {
            alert("初始化失败请检查配置");
        }
    },
    /**
     * 初始化*/
    init(p_provider, p_alg, p_path) {
        let ks_provider, ks_alg, ks_path, lRet;
        if (p_provider != null && p_provider != "") {
            ks_provider = p_provider;
        }
        if (p_alg != null && p_alg != "") {
            ks_alg = p_alg;
        }
        if (p_path != null && p_path != "") {
            ks_path = p_path;
        }
        if (isIEBrowser()) {
            lRet = SecCtrl.KS_SetProv(ks_provider, ks_alg, ks_path);
            if (lRet != 0) {
                alert(SecCtrl.KS_GetLastErrorMsg());
            }
            return true;
        } else {
            return false;
        }
    },

    /**
     * 加载当前环境所有CA列表
     * @returns {boolean}
     */
    getCaKeyInfo: function (callback) {
        this.certInfo.random = SecCtrl.KS_GenRandom(16)
        this.certInfo.base64cert = SecCtrl.KS_GetCert(2);
        this.certInfo.certserial = SecCtrl.KS_GetCertInfo(this.certInfo.base64cert, 2)
        this.certInfo.certName = SecCtrl.KS_GetCertInfo(this.certInfo.base64cert, 1008)
        this.certInfo.subject_cn = SecCtrl.KS_GetCertInfo(this.certInfo.base64cert, 1008)
        // this.certInfo.validstarttime = SecCtrl.KS_GetCertInfo(this.certInfo.base64cert, 11);//证书开始时间：
        // this.certInfo.validendtime = SecCtrl.KS_GetCertInfo(this.certInfo.base64cert, 12);//证书到期时间：
        this.certInfo.validstarttime = formFilter(SecCtrl.KS_GetCertInfo(this.certInfo.base64cert, 11));//证书开始时间：
        this.certInfo.validendtime = formFilter(SecCtrl.KS_GetCertInfo(this.certInfo.base64cert, 12));//证书到期时间：
        // this.certInfo.certName = danweiName(this.certInfo.certName)
        this.certInfo.caLegalCode = SecCtrl.KS_GetCertInfo(this.certInfo.base64cert,1002);
        console.log('this.certInfo',this.certInfo)
        callback && callback(this.certInfo);
    },
    /**
     * 验证密码并生成签名
     * @param inData
     * @param keyPin
     * @param successCallback
     * @returns {string|boolean|*}
     */
    getSignData: function () {
        return this.certInfo.certsigndata = SecCtrl.KS_SignData(this.certInfo.random, 0)
    },
};

function formFilter(data) {
    var qyear = new Date().getFullYear();
    var q2year = qyear.toString().slice(0, 2);
    var time = q2year + data;
    var year = time.substring(0, 4);
    var month = time.substring(4, 6);
    var date = time.substring(6, 8);
    var hour = time.substring(8, 10);
    var minute = time.substring(10, 12);
    var second = time.substring(12, 14);
    // console.log(time,year,month,date,hour,minute,second)
    return year + "-" + month + "-" + date + " " + hour + ":" + minute + ":" + second;
}
export default Hnca